import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'ModalTemplate',
  props: ['config', 'currentStep'],
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const randKey = computed(() => {
  return (Math.random() + 1).toString(36).substring(7);
})


const __returned__ = { props, randKey }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})